import { RootState } from "../../store";

export const selectAnonymousComplaint = (state: RootState) => state.anonymousComplaint;